export const initialwidgets = {};
